import React from 'react'

type Props = {
  className?: string,
}

const GDPREnglish = (props: Props) => {
  return (
    <div className={props.className}>
      <p>Statusfälgar i Sverige AB (559329-8051) processes personal data in accordance with the General Data Protection Regulation (GDPR). You consent to this when you visit our website and place an order. Here we explain what we do with your information:</p>
      <ul>
        <li>We only use the information for the purpose stated.</li>
        <li>We do not collect and store information that is not necessary for the stated purpose.</li>
        <li>We clearly communicate how personal data is collected, stored, and used, and ensure that the rights of affected individuals are respected.</li>
        <li>We ensure that the processing of personal data is traceable and that we or our data processors are responsible for the processing.</li>
        <li>We ensure that personal data is accessible in the manner we have specified.</li>
        <li>We ensure that personal data is not deleted or altered due to negligence or intent.</li>
      </ul>
      <p>
        If you have questions or if you object to how we process your personal data, please contact us at info@statusfalgar.se
        What personal data does Statusfälgar i Sverige AB collect?
      </p>
      <ul>
        <li>Social security number</li>
        <li>Phone number</li>
        <li>IP number</li>
        <li>Email</li>
        <li>First name & Last name</li>
        <li>Address</li>
        <li>Registration number</li>
      </ul>

      <h3>Why do you collect this information and for what purpose?</h3>
      <p>
        We collect your personal information in order to fulfill your order. Only necessary information is collected to be able to deliver the goods to you. We also collect information for warranty purposes related to your order. Explained below:
      </p>
      <ul>
        <li>We collect your social security number to be able to offer you secure and personalized payment options such as invoice, credit card, and installment payments. We also collect your social security number for future warranty issues related to your order. You consent to this when you shop with us.</li>
        <li>We collect your phone number to be able to contact you regarding issues related to your order and to reject your shipment if needed.</li>
        <li>We collect your IP number to protect you and ourselves against internet fraud.</li>
        <li>We collect your email address to be able to email you an order confirmation and contact you regarding issues related to your order.</li>
        <li>We collect your name and surname to be able to send the goods and create a personalized receipt. If you choose to pick up the products from us, we collect this information so that you can identify yourself when contacting Statusfälgar in Sweden.</li>
        <li>We collect your address to be able to deliver your ordered goods. Even if you choose to pick up your products from us, we still collect your address to be able to send additional products/parts if needed.</li>
        <li>We collect your car&#39;s registration number to ensure fitment related to your order. For example, to ensure that wheels, tires, and accessories fit your car.</li>
      </ul>
      <p>
        Important to know: It is you who approves whether we can access your personal information. Unfortunately, we cannot process your request if you do not approve the terms. You approve the terms when making a purchase from Statusfälgar in Sweden. If you have approved the terms and wish to withdraw your consent, you can email our data protection officer at info@statusfalgar.se and request to be deleted from our systems.
      </p>

      <h2>FAQ</h2>
      <strong>How long do you store my information?</strong>
      <p>
        We store your information as long as it is relevant to manage your order history or until you request us to delete them. We store your information to be able to assist you with future issues related to your order.
        <br />
        If you want your information to be deleted, please contact us at info@statusfalgar.se or 0852705264.
      </p>
      <strong>Where do you store my information?</strong>
      <p>
        We store your information in a secure and encrypted database where only Statusfälgar in Sweden can access your personal data. When you place an online order, your information is stored with Svea Ekonomi, Walley, and Statusfälgar in Sweden. You can request to have your information deleted at any time by contacting info@statusfalgar.se.
      </p>
      <strong>I want you to delete my information, how do I do that?</strong>
      <p>
        You contact the Data Protection Officer at Statusfälgar in Sweden and request to have your information deleted. Contact is made via email: info@statusfalgar.se.
      </p>
      <strong>I want to change the information you have about me, how do I do that?</strong>
      <p>
        You contact the Data Protection Officer at info@statusfalgar.se and request to have your information changed according to your preferences.
      </p>
      <strong>I want to access the information you have registered about me</strong>
      <p>You contact info@statusfalgar.se or 0852705264 and request to access it.</p>
      <strong>I have signed up for your newsletter but no longer wish to be subscribed, how do I do that?</strong>

      <p>It&#39;s easy! Email info@statusfalgar.se and we will promptly remove you within 72 hours.</p>
      <strong>Who has access to my information?</strong>

      <p>Statusfälgar in Sweden AB, Nshift, relevant shipping company, Svea Ekonomi, and Walley.</p>
      <p>
        We use SSL to protect the traffic between you and us.
        As web protection, SSL protocol (Secure Sockets Layer) is used. SSL enables strong encryption of the connection between the user&#39;s web browser and the web server. The encryption protects the data traffic in a way that prevents outsiders from accessing confidential information by tracking the connection.
      </p>
    </div>
  )
}

export default GDPREnglish